import { render, staticRenderFns } from "./Article_show.vue?vue&type=template&id=6f367b01&"
import script from "./Article_show.vue?vue&type=script&lang=js&"
export * from "./Article_show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports